import { CodeleapQueryClient } from '@codeleap/common'
import { QueryClient } from '@tanstack/react-query'
import { getFirebase } from '../firebaseApp'

const queryClient = new CodeleapQueryClient(
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  })
)

if (!(typeof window === 'undefined')) {
  // getFirebase().then(fb => {
  //   reactQueryClient.setDefaultOptions({
  //     queries: {
  //       enabled: !!fb.auth().currentUser?.uid,
  //     },
  //   })
  //   fb.auth().onAuthStateChanged((user) => {
  //     reactQueryClient.setDefaultOptions({
  //       queries: {
  //         enabled: !!user?.uid,
  //       },
  //     })
  //   })
  // })
  // const localStoragePersister = createSyncStoragePersister({
  //   storage: window.localStorage,
  // })
  // persistQueryClient({
  //   queryClient: reactQueryClient,
  //   persister: localStoragePersister,
  // })
}

export { queryClient }
